import { FORM_TYPE, onPasswordResetSubmit } from '@atlas/react-forms';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

import {
  type ResetPasswordResponse,
  activeFormsRequest,
  resetPasswordRequest,
} from 'api/forms';
import { Form } from 'components/Form';
import Loader from 'components/Loader';
import { useNotifications } from 'store';
import useLayout from 'utils/layout';
import { useSearchQuery } from 'utils/location';
import { Translation, useTranslation } from 'utils/translations';

import styles from './ResetPassword.module.scss';

const getActiveForms = () =>
  activeFormsRequest({
    query: {
      formType: FORM_TYPE.PASSWORD_RESET,
    },
  });

function ResetPasswordEmail() {
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchQuery();
  const [{ add }] = useNotifications();
  const [location, setLocation] = useLocation();
  const layout = useLayout();
  const successText = useTranslation('password_updated_successfully');

  const token = searchParams.get('token');

  const handleSubmit = onPasswordResetSubmit(async (values) => {
    if (!token) return;
    setIsLoading(true);
    const { id, ...rest } = values;

    try {
      return await resetPasswordRequest({
        body: {
          id: Number(id),
          resetToken: token,
          values: rest,
        },
      });
    } catch (error) {
      add({
        text: (error as Error).message,
      });
    } finally {
      setIsLoading(false);
    }
  });

  const onSubmitHandler = (clientData: ResetPasswordResponse) => {
    if (!clientData.success) return;

    add({
      text: successText,
    });
    setLocation(`${location}?passwordResetSuccess=true`);
  };

  useEffect(() => {
    if (token) return;
    setLocation('/signin');
  }, [token, setLocation]);

  return (
    <div className={cx(styles.content, styles[layout])}>
      <h3 className={styles.title}>
        <Translation message="set_new_password" />
      </h3>
      <p className={styles.description}>
        <Translation
          message="password_must_contain_at_least"
          params={{ count: 6 }}
        />
      </p>
      {isLoading ? (
        <Loader />
      ) : (
        <Form
          formType={FORM_TYPE.PASSWORD_RESET}
          className={cx(styles.form, styles[layout])}
          // @ts-ignore
          handleSubmit={handleSubmit}
          // @ts-ignore
          onSubmit={onSubmitHandler}
          getActiveForms={getActiveForms}
          submitButtonText="form_submit_reset_password"
        />
      )}
    </div>
  );
}

export default ResetPasswordEmail;
